import { ref, computed, Ref } from "vue";
import { RenrakuDetail, RenrakuReadList } from "@/types/KaisyaRenraku";
import { RenrakuService } from "@/service/RenrakuService";

/*
 * 詳細取得処理
 */
export function useRenrakuDetail() {
  const loading = ref(0); // APIで読み込みをする本数
  const isError = ref(false);

  const renrakuDetail: Ref<RenrakuDetail | null> = ref(null);
  const readList = ref<RenrakuReadList[]>();

  // ログインユーザーに関連する会社連絡で既読以外を取得する
  const srv = new RenrakuService();

  // お知らせ詳細情報の取得
  const getDetail = async(oshiraseId: number) => {
    loading.value++
    renrakuDetail.value = await srv.getRenrakuDetail(oshiraseId)
    loading.value--
  }

  // お知らせに対する各ユーザーの既読情報の取得
  const getReadList = async(oshiraseId: number) => {
    loading.value++
    readList.value = await srv.getRenrakuReadList(oshiraseId)
    loading.value--
  }

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  });

  return {
    isLoading,
    isError,
    getDetail,
    getReadList,
    renrakuDetail,
    readList,
  }
}
